"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5828],{

/***/ 71962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FarmPage": function() { return /* reexport */ FarmPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Paragraph/ParagraphRenderer.tsx
var ParagraphRenderer = __webpack_require__(67025);
// EXTERNAL MODULE: ./src/components/Layout/Metatags.tsx
var Metatags = __webpack_require__(58005);
// EXTERNAL MODULE: ./src/components/Node/Farm/FarmPremiumMenu.tsx
var FarmPremiumMenu = __webpack_require__(15013);
// EXTERNAL MODULE: ./src/components/Node/Farm/FarmHeader.tsx
var FarmHeader = __webpack_require__(86479);
// EXTERNAL MODULE: ./src/components/Node/Farm/FarmRatings.tsx + 37 modules
var FarmRatings = __webpack_require__(11382);
// EXTERNAL MODULE: ./src/components/Node/Farm/FarmContact.tsx + 1 modules
var FarmContact = __webpack_require__(7622);
// EXTERNAL MODULE: ./src/context/FarmContext.ts
var FarmContext = __webpack_require__(66771);
;// CONCATENATED MODULE: ./src/components/Node/FarmPage/FarmPage.tsx








var FarmPage = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Metatags/* Metatags */.A, {
                metatags: data.metatags
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmHeader/* FarmHeader */.y, {
                data: data.farm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmPremiumMenu/* FarmPremiumMenu */.x, {
                data: data.farm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmContext/* FarmContext.Provider */.z.Provider, {
                value: {
                    farm: data.farm
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphRenderer/* ParagraphRenderer */.W, {
                    paragraphs: data.content,
                    wrapperProps: {
                        py: 0
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmRatings/* FarmRatings */.x, {
                data: data.farm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmContact/* FarmContact */.d, {
                data: data.farm
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Node/FarmPage/index.ts



/***/ })

}]);